import React from 'react';
import "../Figure.css"


function Figure3() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th></th>
              <th> Uninduced SpaC </th>
              <th> Early induction of SpaC </th>
              <th> Late induction of SpaC </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td> <b> Signal </b></td>
              <td> 1 700 </td>
              <td> 2 000 </td>
              <td> 1 500 </td>
            </tr>
          </tbody>
        </table>
    </div>
  );
}

export default Figure3;